import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  makeStyles,
  Paper,
  TextField,
  Typography,
  Divider,
  InputAdornment,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Select,
  MenuItem,
  Checkbox,
  FormControlLabel,
  CircularProgress,
} from "@material-ui/core";
import { Info, Edit } from "@material-ui/icons";
import { green } from "@material-ui/core/colors";
import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import { fetchDSBatchDetails } from "../../../containers/actions/common/saslAction";
import {
  Visibility,
  Search as SearchIcon,
  ArrowDropDown,
  Refresh,
  ChevronLeft,
  ChevronRight,
  ArrowForwardIos,
} from "@material-ui/icons";
import { PDFViewer } from "../sasl/batch/updateBatch/StructuredInformation/PDFViewer";
import { appUrl } from "../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  formLabel: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    minWidth: "150px",
    paddingRight: theme.spacing(2),
    textAlign: "right",
  },
  fixedLabel: {
    width: 180,
    textAlign: "left",
    paddingRight: theme.spacing(2),
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  requiredStar: {
    color: "red",
    marginLeft: 4,
  },
  sectionTitle: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
    backgroundColor: "#f0f8ff",
    padding: theme.spacing(1),
    borderRadius: 4,
    fontWeight: 600,
  },
  bowlSection: {
    marginBottom: theme.spacing(3),
    border: "1px solid #e0e0e0",
    borderRadius: 8,
    padding: theme.spacing(2),
    backgroundColor: "#fafafa",
  },
  testTable: {
    '& .MuiTableCell-head': {
      backgroundColor: '#f5f5f5',
      fontWeight: 'bold',
    },
  },
  rowContainer: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    border: '1px solid #e0e0e0',
    borderRadius: 4,
    backgroundColor: '#fff',
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  rowTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}));

const DigitizedConsumption = (props) => {
  const { initialData, onClose, schrockenCustomFileID, digitizedData, batchDetails } = props;
  const dispatch = useDispatch();
  const [formValues, setFormValues] = useState(initialData || {});
  const [originalValues, setOriginalValues] = useState(initialData || {});
  const [editedValues, setEditedValues] = useState(initialData || {});
  const [showingOriginal, setShowingOriginal] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [editModalValidationError, setEditModalValidationError] = useState("");
  const [saving, setSaving] = useState(false);
  const [enableAllFieldsEdit, setEnableAllFieldsEdit] = useState(false);
  const [isFetchingHistory, setIsFetchingHistory] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const [modalData, setModalData] = useState({
    field: "",
    historyData: [],
    hasHistory: false,
  });
  const [apiDigitalizationCodes, setApiDigitalizationCodes] = useState([]);
  const [editModalData, setEditModalData] = useState({
    fieldKey: "",
    fieldLabel: "",
    bowlIndex: -1,
    rowIndex: -1,
    currentValue: "",
    originalValue: "",
    confidenceLevel: 0,
    digitalizationCode: "",
    comment: "",
  });
  const [validationCounts, setValidationCounts] = useState({
    noOfFieldsToBeReviewed: 0,
    noOfFieldsReviewed: 0,
  });
  const [apiData, setApiData] = useState(initialData || {});
  const [originalData, setOriginalData] = useState(initialData || {});
  const [editedData, setEditedData] = useState(initialData || {});
  const classes = useStyles();

  const getConsumptionJSONEdited = () => {
    if (batchDetails?.digitizedExtractedData && Array.isArray(batchDetails.digitizedExtractedData)) {
      const consumptionDoc = batchDetails.digitizedExtractedData.find(
        doc => doc.documentType === 'ConsumptionDetails'
      );
      return consumptionDoc?.ConsumptionDetailsJSONOriginal || null;
    }
    return null;
  };

  const hasConsumptionJSONEditedData = () => {
    const data = batchDetails?.consumptionJSONEdited;
    if (data && typeof data === 'object' && Array.isArray(data.bowls)) {
      return data.bowls.length > 0;
    }
    return false;
  };

 
  const fieldMapping = {
    bowl: "Bowl",
    item_no: "Item No",
    consumed_material_number: "Consumed Material Number",
    actual_component_quantity_consumed: "Quantity Consumed",
    consumption_batch_number: "Consumption Batch Number",
    quantity_units: "UoM",
  };

  const calculateValidationCounts = (data) => {
    let noOfFieldsToBeReviewed = 0;
    let noOfFieldsReviewed = 0;
  
    if (data.bowls && Array.isArray(data.bowls)) {
      data.bowls.forEach((bowl) => {
        if (bowl.bowl?.needValidation === true) {
          noOfFieldsToBeReviewed++;
        } else if (
          bowl.bowl?.needValidation === false &&
          (bowl.bowl?.reasonCode || bowl.bowl?.comment)
        ) {
          noOfFieldsReviewed++;
        }
  
        if (bowl.rows && Array.isArray(bowl.rows)) {
          bowl.rows.forEach((row) => {
            Object.keys(row).forEach((key) => {
              if (row[key]?.needValidation === true) {
                noOfFieldsToBeReviewed++;
              } else if (
                row[key]?.needValidation === false &&
                (row[key]?.reasonCode || row[key]?.comment)
              ) {
                noOfFieldsReviewed++;
              }
            });
          });
        }
      });
    }
  
    return { noOfFieldsToBeReviewed, noOfFieldsReviewed };
  };

  useEffect(() => {
    let dataToUse = initialData || { bowls: [] };
    let originalDataToUse = initialData || { bowls: [] };
  
    // Get test data for needValidation scenario
    const extractedData = getConsumptionJSONEdited();
    if (extractedData && extractedData.bowls) {
      //console.log("Using test data with needValidation fields");
      originalDataToUse = extractedData;
      // Also use as main data if no edited data exists
      if (!hasConsumptionJSONEditedData()) {
        dataToUse = extractedData;
      }
    }
  
    if (hasConsumptionJSONEditedData()) {
      //console.log("Using consumptionJSONEdited data");
      dataToUse = batchDetails.consumptionJSONEdited;
      setEditedValues(dataToUse);
    }
  
    setFormValues(dataToUse);
    setOriginalValues(originalDataToUse);
    setEditedValues(dataToUse);
  
    const counts = calculateValidationCounts(dataToUse);
    setValidationCounts(counts);
  }, [initialData, batchDetails]);
  
  useEffect(() => {
    if (batchDetails?.consumptionJSONEdited && !showingOriginal) {
      if (hasConsumptionJSONEditedData()) {
        //console.log("Updating formValues with new consumptionJSONEdited data");
        setFormValues(batchDetails.consumptionJSONEdited);
        setEditedValues(batchDetails.consumptionJSONEdited);
      }
      const counts = calculateValidationCounts(batchDetails.consumptionJSONEdited);
      setValidationCounts(counts);
    }
  }, [batchDetails?.consumptionJSONEdited, showingOriginal]);

  useEffect(() => {
    if (batchDetails?.consumptionJSONEdited && !showingOriginal) {
      if (hasConsumptionJSONEditedData()) {
        //console.log("Updating formValues with new consumptionJSONEdited data");
        setFormValues(batchDetails.consumptionJSONEdited);
        setEditedValues(batchDetails.consumptionJSONEdited);
        setApiData(batchDetails.consumptionJSONEdited);
        setEditedData(batchDetails.consumptionJSONEdited);
      }
    }
  }, [batchDetails?.consumptionJSONEdited, showingOriginal]);

  useEffect(() => {
    const fetchDigitalizationCodes = async () => {
      try {
        const response = await axios.get(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/Admin/fetchDigitalizationCodes`
        );
        if (response.data.status && response.data.digitalizationCodesList) {
          const activatedCodes = response.data.digitalizationCodesList
            .filter(code => code.activated && !code.markForDelete)
            .map(code => ({
              code: code.digitalizationCode,
              description: code.digitalizationCodeDescription
            }));
          setApiDigitalizationCodes(activatedCodes);
        }
      } catch (error) {
        console.error('Error fetching digitalization codes:', error);
      }
    };
    fetchDigitalizationCodes();
  }, []);

  
  const handleToggleVersion = () => {
    if (showingOriginal) {
      setFormValues(editedValues);
      setShowingOriginal(false);
    } else {
      setFormValues(originalValues);
      setShowingOriginal(true);
    }
  };

  const shouldShowInfoIcon = (bowlIndex, rowIndex, fieldKey) => {
    // Only show info icon when displaying edited data (not original)
    if (showingOriginal) return false;
    
    const currentConsumptionData = batchDetails?.consumptionJSONEdited;
    if (!currentConsumptionData?.bowls?.[bowlIndex]) return false;
    
    const field = rowIndex === -1
      ? currentConsumptionData.bowls[bowlIndex][fieldKey]
      : currentConsumptionData.bowls[bowlIndex].rows?.[rowIndex]?.[fieldKey];
    
    return field && field.needValidation === false && (field.reasonCode || field.comment);
  };

  const shouldShowEditForValidation = (bowlIndex, rowIndex, fieldKey) => {
    if (fieldKey === 'bowl' || showingOriginal) return false;
    
    // First check current formValues (this is what's being rendered)
    if (formValues?.bowls?.[bowlIndex]) {
      const field = rowIndex === -1
        ? formValues.bowls[bowlIndex][fieldKey]
        : formValues.bowls[bowlIndex].rows?.[rowIndex]?.[fieldKey];
      
      if (field && field.needValidation === true) {
        return true;
      }
    }
    
    // Check edited data 
    const currentConsumptionData = batchDetails?.consumptionJSONEdited;
    if (currentConsumptionData?.bowls?.[bowlIndex]) {
      const field = rowIndex === -1
        ? currentConsumptionData.bowls[bowlIndex][fieldKey]
        : currentConsumptionData.bowls[bowlIndex].rows?.[rowIndex]?.[fieldKey];
      
      if (field && field.needValidation === true) {
        return true;
      }
    }
    
    // Check original consumption data structure
    if (batchDetails?.digitizedExtractedData && Array.isArray(batchDetails.digitizedExtractedData)) {
      const consumptionDoc = batchDetails.digitizedExtractedData.find(
        doc => doc.documentType === 'ConsumptionDetails'
      );
      
      // Check if the original data uses 'bowls' structure (matching API response)
      if (consumptionDoc?.ConsumptionDetailsJSONOriginal?.bowls) {
        const bowlsArray = consumptionDoc.ConsumptionDetailsJSONOriginal.bowls;
        
        if (Array.isArray(bowlsArray) && bowlsArray[bowlIndex]) {
          const bowl = bowlsArray[bowlIndex];
          
          if (rowIndex === -1) {
            // Bowl-level field
            const bowlField = bowl[fieldKey];
            return bowlField && bowlField.needValidation === true;
          } else {
            // Row-level field
            if (bowl.rows && Array.isArray(bowl.rows) && bowl.rows[rowIndex]) {
              const row = bowl.rows[rowIndex];
              const rowField = row[fieldKey];
              return rowField && rowField.needValidation === true;
            }
          }
        }
      }
      // Fallback: Check if the original data uses 'consumption' structure
      else if (consumptionDoc?.ConsumptionDetailsJSONOriginal?.consumption) {
        const consumptionArray = consumptionDoc.ConsumptionDetailsJSONOriginal.consumption;
        
        if (Array.isArray(consumptionArray) && consumptionArray[bowlIndex]) {
          const bowl = consumptionArray[bowlIndex];
          
          if (rowIndex === -1) {
            // Bowl-level field
            const bowlField = bowl[fieldKey];
            return bowlField && bowlField.needValidation === true;
          } else {
            // Row-level field
            if (bowl.rows && Array.isArray(bowl.rows) && bowl.rows[rowIndex]) {
              const row = bowl.rows[rowIndex];
              const rowField = row[fieldKey];
              return rowField && rowField.needValidation === true;
            }
          }
        }
      }
    }
    
    return false;
  };

  // Helper function to check if editing should be disabled based on needValidation flags
  const isEditingDisabled = () => {
    // Get current consumption data (edited or original)
    const currentConsumptionData = batchDetails?.consumptionJSONEdited || getConsumptionJSONEdited();
    if (!currentConsumptionData?.bowls) return true;
    
    // Check if any field has needValidation: true
    const hasFieldsNeedingValidation = currentConsumptionData.bowls.some(bowl => {
      // Check bowl-level fields
      if (bowl.bowl?.needValidation === true) return true;
      
      // Check row-level fields
      if (bowl.rows && Array.isArray(bowl.rows)) {
        return bowl.rows.some(row => {
          return Object.keys(row).some(fieldKey => {
            return row[fieldKey]?.needValidation === true;
          });
        });
      }
      
      return false;
    });
    
    // Enable editing if any field has needValidation: true
    return !hasFieldsNeedingValidation;
  };

  // const fetchFieldHistory = async (fieldName, currentValue, bowlIndex, rowIndex = -1) => {
  //   setIsFetchingHistory(true);
  //   try {
  //     let id;
  //     const currentConsumptionData = batchDetails?.consumptionJSONEdited || getConsumptionJSONEdited();
      
  //     if (rowIndex === -1) {
  //       id = currentConsumptionData?.bowls?.[bowlIndex]?.ID || String.fromCharCode(65 + bowlIndex);
  //     } else {
  //       id = currentConsumptionData?.bowls?.[bowlIndex]?.rows?.[rowIndex]?.item_no?.value || `Row_${rowIndex + 1}`;
  //     }

  //     const response = await axios.post(
  //       `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/fetchExtractedDataHistory`,
  //       {
  //         schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
  //         dataFieldName: fieldName,
  //         documentType: "ConsumptionDetails",
  //         ID: id,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //       }
  //     );

  //     if (response.data.status && response.data.fieldDataHistory && response.data.fieldDataHistory.length > 0) {
  //       const historyData = response.data.fieldDataHistory.map(record => ({
  //         timestamp: record.lastUpdatedDate ? new Date(record.lastUpdatedDate).toLocaleString() : new Date().toLocaleString(),
  //         before: record.beforeValue || "N/A",
  //         after: record.afterValue || "N/A",
  //         updatedBy: record.lastUpdatedBy || "System",
  //       }));

  //       setModalData({
  //         field: fieldName,
  //         historyData: historyData,
  //         hasHistory: true,
  //       });
  //     } else {
  //       setModalData({
  //         field: fieldName,
  //         historyData: [],
  //         hasHistory: false,
  //       });
  //     }
  //     setOpenModal(true);
  //   } catch (error) {
  //     console.error("Error fetching field history:", error);
  //     setModalData({
  //       field: fieldName,
  //       historyData: [],
  //       hasHistory: false,
  //     });
  //     setOpenModal(true);
  //   } finally {
  //     setIsFetchingHistory(false);
  //   }
  // };
  const fetchFieldHistory = async (fieldName, currentValue, bowlIndex, rowIndex = -1) => {
    setIsFetchingHistory(true);
    try {
      // Use original data source for getting the correct IDs
      const originalConsumptionData = getConsumptionJSONEdited();
      
      // Get the bowl ID from the original data structure
      const bowlID = originalConsumptionData?.bowls?.[bowlIndex]?.ID || (bowlIndex + 1);
      
      // Create the payload according to the required structure
      const payload = {
        schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
        documentType: "ConsumptionDetails",
        dataFieldName: fieldName,
        ID: bowlID,
      };
      
      // Add rowID only for row-level fields
      if (rowIndex !== -1) {
        const rowID = originalConsumptionData?.bowls?.[bowlIndex]?.rows?.[rowIndex]?.row_id || (rowIndex + 1);
        payload.rowID = rowID;
      }
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/fetchExtractedDataHistory`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
  
      if (response.data.status && response.data.fieldDataHistory && response.data.fieldDataHistory.length > 0) {
        const historyData = response.data.fieldDataHistory.map((record) => ({
          timestamp: record.lastUpdatedDate ? new Date(record.lastUpdatedDate).toLocaleString() : new Date().toLocaleString(),
          before: record.beforeValue || "N/A",
          after: record.afterValue || "N/A",
          updatedBy: record.lastUpdatedBy || "System",
        }));
  
        setModalData({
          field: fieldName,
          historyData,
          hasHistory: true,
        });
      } else {
        setModalData({
          field: fieldName,
          historyData: [],
          hasHistory: false,
        });
      }
      setOpenModal(true);
    } catch (error) {
      console.error("Error fetching field history:", error);
      setModalData({
        field: fieldName,
        historyData: [],
        hasHistory: false,
      });
      setOpenModal(true);
    } finally {
      setIsFetchingHistory(false);
    }
  };
  const handleOpenEditModal = (bowlIndex, rowIndex, fieldKey, fieldLabel) => {
    const currentValue = rowIndex === -1
      ? getValueForBowlField(bowlIndex, fieldKey)
      : getValueForBowlField(bowlIndex, fieldKey, rowIndex);
    const confidence = rowIndex === -1
      ? getConfidenceForBowlField(bowlIndex, fieldKey)
      : getConfidenceForBowlField(bowlIndex, fieldKey, rowIndex);
  
    let wasPreviouslyEdited = false;
    let reasonCode = "";
    let comment = "";
    
    // Only check for edits in the edited data, not original data
    const currentConsumptionData = batchDetails?.consumptionJSONEdited;
  
    if (currentConsumptionData?.bowls?.[bowlIndex]) {
      if (rowIndex === -1) {
        const fieldData = currentConsumptionData.bowls[bowlIndex][fieldKey];
        if (fieldData?.reasonCode || fieldData?.comment) {
          wasPreviouslyEdited = true;
          reasonCode = fieldData.reasonCode || "";
          comment = fieldData.comment || "";
        }
      } else {
        const fieldData = currentConsumptionData.bowls[bowlIndex].rows?.[rowIndex]?.[fieldKey];
        if (fieldData?.reasonCode || fieldData?.comment) {
          wasPreviouslyEdited = true;
          reasonCode = fieldData.reasonCode || "";
          comment = fieldData.comment || "";
        }
      }
    }
  
    setEditModalData({
      fieldKey,
      fieldLabel,
      bowlIndex,
      rowIndex,
      currentValue,
      originalValue: currentValue,
      confidenceLevel: confidence,
      digitalizationCode: reasonCode,
      comment,
      wasPreviouslyEdited,
    });
    setEditModalValidationError("");
    setOpenEditModal(true);
  };

  const getValueForBowlField = (bowlIndex, fieldKey, rowIndex = -1, dataSource = formValues) => {
    if (dataSource.bowls && dataSource.bowls[bowlIndex]) {
      if (rowIndex === -1) {
        const fieldData = dataSource.bowls[bowlIndex][fieldKey];
        return fieldData && typeof fieldData === 'object' && fieldData.value !== undefined
          ? fieldData.value || ''
          : fieldData || '';
      } else {
        const row = dataSource.bowls[bowlIndex].rows?.[rowIndex];
        if (row && row[fieldKey]) {
          const fieldData = row[fieldKey];
          return fieldData && typeof fieldData === 'object' && fieldData.value !== undefined
            ? fieldData.value || ''
            : fieldData || '';
        }
      }
    }
    return '';
  };

  const getConfidenceForBowlField = (bowlIndex, fieldKey, rowIndex = -1) => {
    // Use the current form values which could be either original or edited
    const dataSource = formValues;
    
    if (dataSource.bowls && dataSource.bowls[bowlIndex]) {
      if (rowIndex === -1) {
        const fieldData = dataSource.bowls[bowlIndex][fieldKey];
        if (fieldData && typeof fieldData === 'object' && fieldData.confidence !== undefined) {
          return parseFloat(fieldData.confidence);
        }
      } else {
        const row = dataSource.bowls[bowlIndex].rows?.[rowIndex];
        if (row && row[fieldKey] && row[fieldKey].confidence !== undefined) {
          return parseFloat(row[fieldKey].confidence);
        }
      }
    }
    return null;
  };

  const getConfidenceDisplay = (bowlIndex, fieldKey, rowIndex = -1) => {
    const confidence = getConfidenceForBowlField(bowlIndex, fieldKey, rowIndex);
    return confidence !== null ? Math.round(confidence) : "N/A";
  };

  const getLevelColor = (level) => {
    if (level === null || level === undefined) return "#cccccc";
    if (level < 80) return "red";
    if (level <= 90) return "orange";
    return "green";
  };

  const isFieldChanged = (bowlIndex, rowIndex, fieldKey) => {
    const currentValue = getValueForBowlField(bowlIndex, fieldKey, rowIndex, formValues);
    const originalValue = getValueForBowlField(bowlIndex, fieldKey, rowIndex, originalValues);
    return currentValue !== originalValue;
  };

  const validateField = (fieldKey, value, bowlIndex = null, rowIndex = null) => {
    const validations = {
      bowl: {
        type: "Text",
        validate: (val) => {
          // Allow empty values
          if (val && val.trim() !== '' && !/^[A-Za-z]$/.test(val)) return "Must be a single letter";
          return null;
        }
      },
      item_no: {
        type: "Alphanumeric",
        validate: (val) => {
          // Allow empty values
          if (val && val.trim() !== '' && !/^[A-Za-z0-9]+$/.test(val)) return "Must be alphanumeric";
          return null;
        }
      },
      consumed_material_number: {
        type: "Numeric",
        validate: (val) => {
          // Allow empty values
          if (val && val.trim() !== '' && !/^\d+$/.test(val)) return "Must be numeric";
          return null;
        }
      },
      actual_component_quantity_consumed: {
        type: "Decimal",
        validate: (val) => {
          // Allow empty values
          if (val && val.trim() !== '' && !/^\d+\.?\d*$/.test(val)) return "Must be a valid number";
          return null;
        }
      },
      consumption_batch_number: {
        type: "Alphanumeric",
        validate: (val) => {
          // Allow empty values
          if (val && val.trim() !== '' && !/^[A-Za-z0-9]+$/.test(val)) return "Must be alphanumeric";
          return null;
        }
      },
      quantity_units: {
        type: "Text",
        validate: (val) => {
          // Allow empty values
          if (val && val.trim() !== '' && val.length > 10) return "Unit should be shorter";
          return null;
        }
      }
    };

    const fieldValidation = validations[fieldKey];
    if (fieldValidation) {
      return fieldValidation.validate(value);
    }
    return null;
  };

  const validateAllFields = () => {
    const errors = {};

    if (formValues.bowls && Array.isArray(formValues.bowls)) {
      formValues.bowls.forEach((bowl, bowlIndex) => {
        const bowlError = validateField('bowl', getValueForBowlField(bowlIndex, 'bowl'));
        if (bowlError) {
          errors[`bowl_${bowlIndex}_bowl`] = bowlError;
        }

        if (bowl.rows && Array.isArray(bowl.rows)) {
          bowl.rows.forEach((row, rowIndex) => {
            Object.keys(row).forEach(fieldKey => {
              const error = validateField(fieldKey, getValueForBowlField(bowlIndex, fieldKey, rowIndex));
              if (error) {
                const errorKey = `bowl_${bowlIndex}_row_${rowIndex}_${fieldKey}`;
                errors[errorKey] = error;
              }
            });
          });
        }
      });
    }

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const getFieldErrorProps = (bowlIndex, rowIndex, fieldKey) => {
    const errorKey = rowIndex === -1
      ? `bowl_${bowlIndex}_${fieldKey}`
      : `bowl_${bowlIndex}_row_${rowIndex}_${fieldKey}`;
    return {
      error: !!validationErrors[errorKey],
      helperText: validationErrors[errorKey]
    };
  };

  const handleBowlInputChange = (bowlIndex, rowIndex, fieldKey, value) => {
    const newValues = { ...formValues };
    if (!newValues.bowls) newValues.bowls = [];
    if (!newValues.bowls[bowlIndex]) newValues.bowls[bowlIndex] = { rows: [] };

    if (rowIndex === -1) {
      newValues.bowls[bowlIndex] = {
        ...newValues.bowls[bowlIndex],
        [fieldKey]: {
          ...newValues.bowls[bowlIndex][fieldKey],
          value: value
        }
      };
    } else {
      if (!newValues.bowls[bowlIndex].rows) newValues.bowls[bowlIndex].rows = [];
      if (!newValues.bowls[bowlIndex].rows[rowIndex]) newValues.bowls[bowlIndex].rows[rowIndex] = {};
      newValues.bowls[bowlIndex].rows[rowIndex] = {
        ...newValues.bowls[bowlIndex].rows[rowIndex],
        [fieldKey]: {
          ...newValues.bowls[bowlIndex].rows[rowIndex][fieldKey],
          value: value
        }
      };
    }

    setFormValues(newValues);
    if (!showingOriginal) {
      setEditedValues(newValues);
    }

    const error = validateField(fieldKey, value, bowlIndex, rowIndex);
    const errorKey = rowIndex === -1
      ? `bowl_${bowlIndex}_${fieldKey}`
      : `bowl_${bowlIndex}_row_${rowIndex}_${fieldKey}`;
    setValidationErrors(prev => ({
      ...prev,
      [errorKey]: error
    }));
  };

  const handleSaveFieldEdit = async () => {
    if (!editModalData.digitalizationCode && !editModalData.comment.trim()) {
      setEditModalValidationError("If reason code is not entered, comment field is mandatory");
      return;
    }
    setEditModalValidationError("");
  
    try {
      setSaving(true);
  
      // Update formValues
      handleBowlInputChange(editModalData.bowlIndex, editModalData.rowIndex, editModalData.fieldKey, editModalData.currentValue);
  
      const currentConsumptionData = batchDetails?.consumptionJSONEdited || getConsumptionJSONEdited() || { bowls: [] };
      //console.log("currentConsumptionData:", JSON.stringify(currentConsumptionData, null, 2))
      const wasFieldNeedingValidation =
        editModalData.rowIndex === -1
          ? currentConsumptionData?.bowls?.[editModalData.bowlIndex]?.[editModalData.fieldKey]?.needValidation === true
          : currentConsumptionData?.bowls?.[editModalData.bowlIndex]?.rows?.[editModalData.rowIndex]?.[editModalData.fieldKey]?.needValidation === true;
  
      const updatedBowls = (formValues.bowls || []).map((bowl, bowlIndex) => {
        const updatedBowl = {
          ID: currentConsumptionData.bowls?.[bowlIndex]?.ID || bowl.ID || String.fromCharCode(65 + bowlIndex),
          bowl: {
            value: getValueForBowlField(bowlIndex, "bowl"),
            confidence: getConfidenceForBowlField(bowlIndex, "bowl"),
            needValidation:
              editModalData.bowlIndex === bowlIndex &&
              editModalData.rowIndex === -1 &&
              editModalData.fieldKey === "bowl"
                ? false
                : currentConsumptionData.bowls?.[bowlIndex]?.bowl?.needValidation ?? false,
            ...(editModalData.bowlIndex === bowlIndex &&
              editModalData.rowIndex === -1 &&
              editModalData.fieldKey === "bowl" && {
                reasonCode: editModalData.digitalizationCode,
                comment: editModalData.comment,
              }),
            ...(currentConsumptionData.bowls?.[bowlIndex]?.bowl?.reasonCode &&
              (editModalData.bowlIndex !== bowlIndex ||
                editModalData.rowIndex !== -1 ||
                editModalData.fieldKey !== "bowl") && {
                reasonCode: currentConsumptionData.bowls[bowlIndex].bowl.reasonCode,
              }),
            ...(currentConsumptionData.bowls?.[bowlIndex]?.bowl?.comment &&
              (editModalData.bowlIndex !== bowlIndex ||
                editModalData.rowIndex !== -1 ||
                editModalData.fieldKey !== "bowl") && {
                comment: currentConsumptionData.bowls[bowlIndex].bowl.comment,
              }),
          },
          rows: bowl.rows?.map((row, rowIndex) => ({
            item_no: {
              value: getValueForBowlField(bowlIndex, "item_no", rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, "item_no", rowIndex),
              needValidation:
                editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "item_no"
                  ? false
                  : currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.item_no?.needValidation ?? false,
              ...(editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "item_no" && {
                  reasonCode: editModalData.digitalizationCode,
                  comment: editModalData.comment,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.item_no?.reasonCode &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "item_no") && {
                  reasonCode: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].item_no.reasonCode,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.item_no?.comment &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "item_no") && {
                  comment: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].item_no.comment,
                }),
            },
            consumed_material_number: {
              value: getValueForBowlField(bowlIndex, "consumed_material_number", rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, "consumed_material_number", rowIndex),
              needValidation:
                editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "consumed_material_number"
                  ? false
                  : currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.consumed_material_number?.needValidation ?? false,
              ...(editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "consumed_material_number" && {
                  reasonCode: editModalData.digitalizationCode,
                  comment: editModalData.comment,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.consumed_material_number?.reasonCode &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "consumed_material_number") && {
                  reasonCode: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].consumed_material_number.reasonCode,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.consumed_material_number?.comment &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "consumed_material_number") && {
                  comment: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].consumed_material_number.comment,
                }),
            },
            actual_component_quantity_consumed: {
              value: getValueForBowlField(bowlIndex, "actual_component_quantity_consumed", rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, "actual_component_quantity_consumed", rowIndex),
              needValidation:
                editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "actual_component_quantity_consumed"
                  ? false
                  : currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.actual_component_quantity_consumed?.needValidation ?? false,
              ...(editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "actual_component_quantity_consumed" && {
                  reasonCode: editModalData.digitalizationCode,
                  comment: editModalData.comment,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.actual_component_quantity_consumed?.reasonCode &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "actual_component_quantity_consumed") && {
                  reasonCode: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].actual_component_quantity_consumed.reasonCode,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.actual_component_quantity_consumed?.comment &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "actual_component_quantity_consumed") && {
                  comment: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].actual_component_quantity_consumed.comment,
                }),
            },
            consumption_batch_number: {
              value: getValueForBowlField(bowlIndex, "consumption_batch_number", rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, "consumption_batch_number", rowIndex),
              needValidation:
                editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "consumption_batch_number"
                  ? false
                  : currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.consumption_batch_number?.needValidation ?? false,
              ...(editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "consumption_batch_number" && {
                  reasonCode: editModalData.digitalizationCode,
                  comment: editModalData.comment,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.consumption_batch_number?.reasonCode &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "consumption_batch_number") && {
                  reasonCode: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].consumption_batch_number.reasonCode,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.consumption_batch_number?.comment &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "consumption_batch_number") && {
                  comment: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].consumption_batch_number.comment,
                }),
            },
            quantity_units: {
              value: getValueForBowlField(bowlIndex, "quantity_units", rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, "quantity_units", rowIndex),
              needValidation:
                editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "quantity_units"
                  ? false
                  : currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.quantity_units?.needValidation ?? false,
              ...(editModalData.bowlIndex === bowlIndex &&
                editModalData.rowIndex === rowIndex &&
                editModalData.fieldKey === "quantity_units" && {
                  reasonCode: editModalData.digitalizationCode,
                  comment: editModalData.comment,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.quantity_units?.reasonCode &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "quantity_units") && {
                  reasonCode: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].quantity_units.reasonCode,
                }),
              ...(currentConsumptionData.bowls?.[bowlIndex]?.rows?.[rowIndex]?.quantity_units?.comment &&
                (editModalData.bowlIndex !== bowlIndex ||
                  editModalData.rowIndex !== rowIndex ||
                  editModalData.fieldKey !== "quantity_units") && {
                  comment: currentConsumptionData.bowls[bowlIndex].rows[rowIndex].quantity_units.comment,
                }),
            },
          })) || [],
        };
        return updatedBowl;
      });
  
      const counts = calculateValidationCounts({ bowls: updatedBowls });
      const { 0: _0, 1: _1, 2: _2, ...cleanedConsumptionData } = currentConsumptionData;
      let noOfFieldsToBeReviewed = counts.noOfFieldsToBeReviewed;
      let noOfFieldsReviewed = counts.noOfFieldsReviewed;
  
      const updatedKvpJson = {
        ...cleanedConsumptionData,
        bowls: updatedBowls,
        document_type: currentConsumptionData.document_type || "ConsumptionDetails",
        folder_name: currentConsumptionData.folder_name || "Patheon",
        site_name: currentConsumptionData.site_name || "Toronto",
        filename: currentConsumptionData.filename || digitizedData?.processedFileName,
        s3_location: currentConsumptionData.s3_location,
        noOfFieldsToBeReviewed,
        noOfFieldsReviewed,
      };
  
      const requestPayload = {
        digitizedExtractedData: {
          vendorMosymphonyID: batchDetails?.vendorMosymphonyID,
          brandOwnerMosymphonyID: batchDetails?.brandOwnerMosymphonyID,
          batchNumber: batchDetails?.vendorBatchNumber,
          kvpJson: updatedKvpJson,
        },
        schrockenDeliveryScheduleID: batchDetails?.schrockenDeliveryScheduleID,
        schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
        schrockenSLID: batchDetails?.schrockenSLID,
         consumptionJSONEdited: updatedKvpJson,
         poNumber:batchDetails?.scheduleAgreementNumber,
         batchNumber:batchDetails?.vendorBatchNumber,
        cdmoOrgID: batchDetails?.vendorMosymphonyID,
        file_type: digitizedData?.documentType || "ConsumptionDetails",
      };
      //console.log("updatedKvpJson is here:", JSON.stringify(updatedKvpJson, null, 2));
      //console.log("Request Payload is here:", JSON.stringify(requestPayload, null, 2));
      const response = await axios.post(
        `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
        requestPayload,
        {
          headers: {
            "Content-Type": "application/json",
          },
          timeout: 10000,
        }
      );
  //console.log("response is here consumption",response)
      if (response.data.success) {
        //console.log("Consumption field saved successfully");
        //setValidationCounts({ noOfFieldsToBeReviewed, noOfFieldsReviewed });
        const refreshData = {
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
        };
        dispatch(fetchDSBatchDetails(refreshData));
        setOpenEditModal(false);
      } else {
        console.error("Failed to save:", response.data.message);
        setEditModalValidationError("Failed to save changes: " + (response.data.message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error saving Consumption field:", error);
      setEditModalValidationError("Error saving changes: " + (error.message || "Network error"));
    } finally {
      setSaving(false);
    }
  };

  const handleSave = async () => {
    if (validateAllFields()) {
      try {
        setSaving(true);

        const existingKvpJson = digitizedData?.kvpJson ? JSON.parse(digitizedData.kvpJson) : {};

        const updatedBowls = formValues.bowls ? formValues.bowls.map((bowl, bowlIndex) => ({
          ID: bowl.ID || bowlIndex + 1,
          bowl: {
            value: getValueForBowlField(bowlIndex, 'bowl'),
            confidence: getConfidenceForBowlField(bowlIndex, 'bowl'),
            needValidation: bowl.bowl?.needValidation ?? false,
            ...(bowl.bowl?.reasonCode && { reasonCode: bowl.bowl.reasonCode }),
            ...(bowl.bowl?.comment && { comment: bowl.bowl.comment }),
          },
          rows: bowl.rows?.map((row, rowIndex) => ({
            item_no: {
              value: getValueForBowlField(bowlIndex, 'item_no', rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, 'item_no', rowIndex),
              needValidation: row.item_no?.needValidation ?? false,
              ...(row.item_no?.reasonCode && { reasonCode: row.item_no.reasonCode }),
              ...(row.item_no?.comment && { comment: row.item_no.comment }),
            },
            consumed_material_number: {
              value: getValueForBowlField(bowlIndex, 'consumed_material_number', rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, 'consumed_material_number', rowIndex),
              needValidation: row.consumed_material_number?.needValidation ?? false,
              ...(row.consumed_material_number?.reasonCode && { reasonCode: row.consumed_material_number.reasonCode }),
              ...(row.consumed_material_number?.comment && { comment: row.consumed_material_number.comment }),
            },
            actual_component_quantity_consumed: {
              value: getValueForBowlField(bowlIndex, 'actual_component_quantity_consumed', rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, 'actual_component_quantity_consumed', rowIndex),
              needValidation: row.actual_component_quantity_consumed?.needValidation ?? false,
              ...(row.actual_component_quantity_consumed?.reasonCode && { reasonCode: row.actual_component_quantity_consumed.reasonCode }),
              ...(row.actual_component_quantity_consumed?.comment && { comment: row.actual_component_quantity_consumed.comment }),
            },
            consumption_batch_number: {
              value: getValueForBowlField(bowlIndex, 'consumption_batch_number', rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, 'consumption_batch_number', rowIndex),
              needValidation: row.consumption_batch_number?.needValidation ?? false,
              ...(row.consumption_batch_number?.reasonCode && { reasonCode: row.consumption_batch_number.reasonCode }),
              ...(row.consumption_batch_number?.comment && { comment: row.consumption_batch_number.comment }),
            },
            quantity_units: {
              value: getValueForBowlField(bowlIndex, 'quantity_units', rowIndex),
              confidence: getConfidenceForBowlField(bowlIndex, 'quantity_units', rowIndex),
              needValidation: row.quantity_units?.needValidation ?? false,
              ...(row.quantity_units?.reasonCode && { reasonCode: row.quantity_units.reasonCode }),
              ...(row.quantity_units?.comment && { comment: row.quantity_units.comment }),
            },
          })) || [],
        })) : [];

        const updatedKvpJson = {
          ...existingKvpJson,
          bowls: updatedBowls,
          document_type: existingKvpJson.document_type || "ConsumptionDetails",
          folder_name: existingKvpJson.folder_name || "Patheon",
          site_name: existingKvpJson.site_name || "Toronto",
          filename: existingKvpJson.filename || digitizedData?.processedFileName,
          s3_location: existingKvpJson.s3_location,
          noOfFieldsToBeReviewed: existingKvpJson.noOfFieldsToBeReviewed,
          noOfFieldsReviewed: existingKvpJson.noOfFieldsReviewed,
        };

        const requestPayload = {
          schrockenDeliveryScheduleID: batchDetails?.schrockenDeliveryScheduleID,
          schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          schrockenSLID: batchDetails?.schrockenSLID,
          consumptionJSONEdited: updatedKvpJson,
          poNumber: batchDetails?.poNumber,
          batchNumber: batchDetails?.batchNumber,
          cdmoOrgID: batchDetails?.vendorMosymphonyID,
          file_type: digitizedData?.documentType || "ConsumptionDetails",
        };

        const response = await axios.post(
          `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/workflow/handleDataExtractionEditedData`,
          requestPayload,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.data.success) {
          setEditedValues(formValues);
          setShowingOriginal(false);

          const refreshData = {
            schrockenDeliveryScheduleBatchID: batchDetails?.schrockenDeliveryScheduleBatchID,
          };
          dispatch(fetchDSBatchDetails(refreshData));

          //console.log('Consumption data saved successfully');
        } else {
          console.error('Failed to save:', response.data.message);
        }
      } catch (error) {
        console.error('Error saving Consumption data:', error);
      } finally {
        setSaving(false);
      }
    }
  };

  const renderBowlField = (bowlIndex, rowIndex, fieldKey, label, placeholder, multiline = false, rows = 1) => (
    <Grid container alignItems="center" spacing={2} className={classes.formField}>
      <Grid item xs={4}>
        <Box display="flex" alignItems="center">
          <Typography style={{ paddingRight: 16, fontWeight: 500 }}>
            {label}
            <span className={classes.requiredStar}>*</span>
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={8}>
        <Box display="flex" alignItems={multiline ? "flex-start" : "center"} gap={1}>
          <Box style={{ width: showingOriginal ? "calc(100% - 60px)" : "calc(100% - 40px)" }}>
            <TextField
              variant="outlined"
              fullWidth
              size="small"
              value={getValueForBowlField(bowlIndex, fieldKey, rowIndex)}
              placeholder={placeholder}
              multiline={multiline}
              rows={rows}
              {...getFieldErrorProps(bowlIndex, rowIndex, fieldKey)}
              InputProps={{
                readOnly: true,
                endAdornment: (
                  <InputAdornment position="end">
                    <Box display="flex" alignItems="center" pl={1}>
                      <Box style={{ width: 1, height: multiline ? 50 : 39, backgroundColor: "#ccc", marginRight: 3 }} />
                      {shouldShowInfoIcon(bowlIndex, rowIndex, fieldKey) ? (
                        <Box
                          onClick={() => {
                            const currentValue = getValueForBowlField(bowlIndex, fieldKey, rowIndex);
                            fetchFieldHistory(fieldKey, currentValue, bowlIndex, rowIndex);
                          }}
                          style={{
                            backgroundColor: "#777",
                            color: "white",
                            borderRadius: 4,
                            padding: "2px 8px",
                            fontSize: "0.75rem",
                            fontWeight: 600,
                            minWidth: 24,
                            textAlign: "center",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Info fontSize="small" />
                        </Box>
                      ) : (
                        <Box style={{
                          backgroundColor: getLevelColor(getConfidenceForBowlField(bowlIndex, fieldKey, rowIndex)),
                          color: "white",
                          borderRadius: 4,
                          padding: "2px 8px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          minWidth: 24,
                          textAlign: "center",
                        }}>
                          {getConfidenceDisplay(bowlIndex, fieldKey, rowIndex)}
                        </Box>
                      )}
                    </Box>
                  </InputAdornment>
                ),
              }}
            />
            {/* BCM-564: Auto-populated indicator */}
            {batchDetails?.consumptionJSONEdited?.bowls?.[bowlIndex]?.rows?.[rowIndex]?.[fieldKey]?.autoPopulated === true && (
              <Typography
                variant="caption"
                style={{
                  color: '#1976d2',
                  fontStyle: 'italic',
                  display: 'block',
                  marginTop: 2
                }}
              >
                {(fieldKey === 'actual_component_quantity_consumed' || fieldKey === 'actual_material_quantity_consumed')
                  ? 'Auto-populated with On-hand Qty from BMS SAP Inventory'
                  : 'Auto-populated from BMS SAP Inventory'}
              </Typography>
            )}
          </Box>
          <Box style={{ width: 32, height: 32, display: "flex", alignItems: multiline ? "flex-start" : "center", justifyContent: "center", ...(multiline && { paddingTop: 4 }) }}>
            {(enableAllFieldsEdit || shouldShowEditForValidation(bowlIndex, rowIndex, fieldKey)) && !shouldShowInfoIcon(bowlIndex, rowIndex, fieldKey) && !showingOriginal && !isEditingDisabled() ? (
              <Box
                onClick={() => handleOpenEditModal(bowlIndex, rowIndex, fieldKey, label)}
                style={{
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Edit fontSize="small" style={{ color: "#EC6535" }} />
              </Box>
            ) : null}
          </Box>
        </Box>
      </Grid>
    </Grid>
  );

  const renderBowlSection = (bowlIndex) => {
    const bowlName = getValueForBowlField(bowlIndex, 'bowl') || `Bowl ${String.fromCharCode(65 + bowlIndex)}`;

    return (
      <div key={bowlIndex} className={classes.bowlSection}>
        <Typography variant="h6" className={classes.sectionTitle}>
          Bowl {bowlName}
        </Typography>
        
        {formValues.bowls?.[bowlIndex]?.rows?.length > 0 ? (
          formValues.bowls[bowlIndex].rows.map((row, rowIndex) => (
            <div key={rowIndex} style={{ marginTop: 16, padding: 16, border: '1px solid #e0e0e0', borderRadius: 4, backgroundColor: '#fff' }}>
              {/* <Typography variant="subtitle1" style={{ marginBottom: 8, fontWeight: 500 }}>
                Row {rowIndex + 1}
              </Typography> */}
              {/* {renderBowlField(bowlIndex, rowIndex, 'item_no', 'Item No', 'Enter Item Number')} */}
              {renderBowlField(bowlIndex, rowIndex, 'consumed_material_number', 'Consumed Material Number', 'Enter Consumed Material Number')}
              {renderBowlField(bowlIndex, rowIndex, 'actual_component_quantity_consumed', 'Quantity Consumed', 'Enter Quantity Consumed')}
              {renderBowlField(bowlIndex, rowIndex, 'quantity_units', 'UoM', 'Enter Unit of Measure (g, kg, etc.)')}
              {renderBowlField(bowlIndex, rowIndex, 'consumption_batch_number', 'Consumption Batch Number', 'Enter Consumption Batch Number')}
            </div>
          ))
        ) : (
          <Typography variant="body2" color="textSecondary">
            No rows available for this bowl.
          </Typography>
        )}
      </div>
    );
  };

  return (
    <>
      {/* Loading overlay when fetching field history */}
      {isFetchingHistory && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Box 
            style={{
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 8,
              textAlign: 'center',
              minWidth: 200,
            }}
          >
            <CircularProgress size={40} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Loading field history...</Typography>
          </Box>
        </Box>
      )}

      {/* Loading overlay when refreshing data */}
      {isRefreshing && (
        <Box
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <Box 
            style={{
              backgroundColor: 'white',
              padding: 24,
              borderRadius: 8,
              textAlign: 'center',
              minWidth: 200,
            }}
          >
            <CircularProgress size={40} style={{ marginBottom: 16 }} />
            <Typography variant="h6">Refreshing data...</Typography>
          </Box>
        </Box>
      )}

      <Grid container direction="column" spacing={2}>
      <Grid item container alignItems="center" spacing={2}>
          <Grid item>
            <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginLeft: "0px",
              }}
              onClick={onClose}
            >
              Back
            </Button>
          </Grid>
          <Grid item>
            <Typography variant="h6">
              Digitized Consumption Pages
            </Typography>
          </Grid>
        </Grid>
        <Grid item>
          <Divider
            style={{
              margin: "0px 0px 0px 0px",
              backgroundColor: "#707070",
              height: 1,
              zIndex: 4,
            }}
          />
        </Grid>
        <Grid item container alignItems="center" spacing={2}>
          <Grid item xs={6}>

            
  
            <Grid item style={{ display: "flex", alignItems: "center" }} spacing={2}>
              {/* <Button
              startIcon={<ChevronLeft fontSize="small" />}
              style={{
                fontWeight: "bold",
                textTransform: "none",
                marginRight: "5px",
              }}
              onClick={onClose}
            >
              Back
            </Button> */}
              <Typography
                variant="h6"
                style={{
                  whiteSpace: "normal",
                  wordBreak: "break-word",
                  marginRight: "8px",
                  flexGrow: 1, 
                }}
              >
                Consumption Pages Data
              </Typography>
              <Box display="flex" gap={1} spacing={2}>
                <Button
                  color="secondary"
                  variant="outlined"
                  onClick={handleToggleVersion}
                  style={{ marginRight: "8px", minWidth: 20, textAlign: "center", size: "20px", textTransform: "none", backgroundColor:"grey",color: "white" }}
                >
                  {showingOriginal ? "Show Edited Version" : "Show Unedited Version"}
                </Button>
              </Box>
            </Grid>
            {/* <Box mt={1}>
    <Typography variant="body2" color="textSecondary">
      Fields to be reviewed: {validationCounts.noOfFieldsToBeReviewed} | Fields reviewed: {validationCounts.noOfFieldsReviewed}
    </Typography>
  </Box> */}
          </Grid>
          <Grid item >
            <Typography variant="h6" style={{paddingTop: "5px"}}>PDF Preview</Typography>
          </Grid>
        </Grid>

        <Grid item container spacing={2}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              {formValues.bowls && Array.isArray(formValues.bowls) ? (
                formValues.bowls.map((_, index) => renderBowlSection(index))
              ) : (
                <Typography variant="body2" color="textSecondary">
                  No consumption data available.
                </Typography>
              )}

              <Box display="flex" alignItems="center" gap={2} mb={2} mt={3}>
                <Typography variant="body2" color="textSecondary">
                  Confidence Levels Legend:{" "}
                </Typography>
                <Grid item style={{ width: "78px" }} />
                {(() => {
                  // Get dynamic confidence levels from batch details
                  const confidenceLevels = batchDetails?.confidenceLevels;
                  const lowConfidenceLimit = confidenceLevels?.lowConfidenceLimit || 80;
                  const highConfidenceLimit = confidenceLevels?.highConfidenceLimit || 90;
                  
                  return (
                    <>
                      <Box
                        style={{
                          backgroundColor: "green",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 30,
                        }}
                      >
                        &gt; {highConfidenceLimit}
                      </Box>
                      <Box
                        style={{
                          backgroundColor: "orange",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 50,
                          marginLeft: 16,
                        }}
                      >
                        {confidenceLevels?.mediumConfidenceLimitMinValue} - {confidenceLevels?.mediumConfidenceLimitMaxValue}
                      </Box>
                      <Box
                        style={{
                          backgroundColor: "red",
                          color: "white",
                          borderRadius: 4,
                          padding: "4px 12px",
                          fontSize: "0.75rem",
                          fontWeight: 600,
                          textAlign: "center",
                          minWidth: 30,
                          marginLeft: 16,
                        }}
                      >
                        &lt; {lowConfidenceLimit}
                      </Box>
                    </>
                  );
                })()}
              </Box>
              <Grid item xs={12}>
                <Box
                  style={{
                    border: "1px solid #ddd",
                    padding: "12px",
                    borderRadius: "4px",
                    backgroundColor: "#f9f9f9",
                  }}
                >
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={enableAllFieldsEdit}
                        onChange={(e) => setEnableAllFieldsEdit(e.target.checked)}
                        color="primary"
                        disabled={isEditingDisabled()}
                      />
                    }
                    label="Apply edit feature to all the fields"
                  />
                  <Typography
                    variant="body2"
                    style={{
                      fontStyle: "italic",
                      color: isEditingDisabled() ? "#999" : "#666",
                      marginTop: "4px",
                    }}
                  >
                    {isEditingDisabled() 
                      ? "No fields require review - all fields have acceptable confidence levels."
                      : "Note - This will enable editing of the high confidence level fields, highlighted in green colors."
                    }
                  </Typography>
                </Box>
              </Grid>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={2}
              style={{
                height: "calc(100vh - 200px)",
                padding: 16,
                overflowY: "auto",
              }}
            >
              <Box
                style={{
                  height: 500,
                  backgroundColor: "#f5f5f5",
                  border: "1px dashed #ccc",
                }}
              >
                {schrockenCustomFileID ? (
                  <PDFViewer schrockenCustomFileID={schrockenCustomFileID} />
                ) : (
                  <Box
                    style={{
                      height: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography>No PDF available</Typography>
                  </Box>
                )}
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Grid>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Box
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: 24,
            boxShadow: 24,
            borderRadius: 8,
            minWidth: 600,
            maxHeight: "80vh",
            overflowY: "auto",
          }}
        >
          <Typography variant="h6" gutterBottom>
            {modalData.field} - Field Data History
          </Typography>

          <Box style={{ maxHeight: "400px", overflowY: "auto" }}>
            <Table>
              <TableHead
                style={{ border: "1px solid grey", backgroundColor: "#7777" }}
              >
                <TableRow
                  style={{ border: "1px solid grey", backgroundColor: "#7777" }}
                >
                  <TableCell>
                    <b>Timestamp</b>
                  </TableCell>
                  <TableCell>
                    <b>Before Value</b>
                  </TableCell>
                  <TableCell>
                    <b>After Value</b>
                  </TableCell>
                  <TableCell>
                    <b>Updated By</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ border: "1px solid grey" }}>
                {modalData.hasHistory ? (
                  modalData.historyData.map((record, index) => (
                    <TableRow key={index}>
                      <TableCell>{record.timestamp}</TableCell>
                      <TableCell>{record.before}</TableCell>
                      <TableCell>{record.after}</TableCell>
                      <TableCell>{record.updatedBy}</TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={4} style={{ textAlign: 'center', padding: '20px' }}>
                      No history found
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>

          <Box display="flex" justifyContent="center" mt={3}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setOpenModal(false)}
            >
              OK
            </Button>
          </Box>
        </Box>
      </Modal>

      

<Modal open={openEditModal} onClose={() => setOpenEditModal(false)}>
  <Box
    style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      backgroundColor: "#fff",
      padding: 24,
      boxShadow: 24,
      borderRadius: 8,
      minWidth: 600,
    }}
  >
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
      <Typography variant="h6">
        Edit {editModalData.fieldLabel} for Bowl{" "}
        {editModalData.bowlIndex >= 0
          ? getValueForBowlField(editModalData.bowlIndex, "bowl") || String.fromCharCode(65 + editModalData.bowlIndex)
          : ""}{" "}
        {editModalData.rowIndex >= 0 ? `, Row ${editModalData.rowIndex + 1}` : ""}
      </Typography>
      <Button onClick={() => setOpenEditModal(false)} style={{ minWidth: "auto" }}>
        ✕
      </Button>
    </Box>

    <Grid container spacing={3}>
      <Grid item xs={6}>
        <Typography variant="body2" gutterBottom style={{ fontWeight: "bold" }}>
          {editModalData.fieldLabel}
        </Typography>
        <Box display="flex" alignItems="center">
          <TextField
            variant="outlined"
            fullWidth
            size="small"
            value={editModalData.currentValue}
                  onChange={(e) => setEditModalData((prev) => ({ ...prev, currentValue: e.target.value }))}
                  onBlur={(e) => {
                    const { value } = e.target;
                    // Trim leading and trailing spaces for string values
                    if (typeof value === "string" && value.trim() !== value) {
                      setEditModalData((prev) => ({ ...prev, currentValue: value.trim() }));
                    }
                  }}
          />
          {(editModalData.confidenceLevel === null || editModalData.confidenceLevel <= 90) &&
            !editModalData.wasPreviouslyEdited && (
              <Box
                onClick={() => {
                  if (editModalData.currentValue === editModalData.originalValue) {
                    setEditModalData((prev) => ({ ...prev, digitalizationCode: "DG001" }));
                  }
                }}
                style={{
                  backgroundColor:
                    editModalData.currentValue === editModalData.originalValue ? "green" : "#cccccc",
                  color: "white",
                  borderRadius: 4,
                  padding: "2px 8px",
                  fontSize: "0.75rem",
                  fontWeight: 600,
                  minWidth: 24,
                  textAlign: "center",
                  cursor: editModalData.currentValue === editModalData.originalValue ? "pointer" : "not-allowed",
                  opacity: editModalData.currentValue === editModalData.originalValue ? 1 : 0.5,
                  marginLeft: 8,
                }}
              >
                ✓
              </Box>
            )}
        </Box>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" gutterBottom style={{ fontWeight: "bold" }}>
          Confidence Level (%)
        </Typography>
        <Typography variant="body2">
          {editModalData.confidenceLevel !== null ? Math.round(editModalData.confidenceLevel) : "N/A"}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" gutterBottom style={{ fontWeight: "bold" }}>
          Digitalization Code / Description
        </Typography>
        <FormControl fullWidth variant="outlined" size="small">
          <Select
            value={editModalData.digitalizationCode}
            onChange={(e) => {
              setEditModalData((prev) => ({ ...prev, digitalizationCode: e.target.value }));
              setEditModalValidationError("");
            }}
            displayEmpty
          >
            <MenuItem value="">
              <em>Select a digitalization code</em>
            </MenuItem>
            {apiDigitalizationCodes.length > 0 ? (
              apiDigitalizationCodes.map((code) => (
                <MenuItem key={code.code} value={code.code}>
                  {code.code} / {code.description}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                <em>No digitalization codes available</em>
              </MenuItem>
            )}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body2" gutterBottom style={{ fontWeight: "bold" }}>
          Comment
        </Typography>
        <TextField
          variant="outlined"
          fullWidth
          size="small"
          placeholder="Enter text here"
          value={editModalData.comment}
          onChange={(e) => {
            if(e.target.value.length < 256){
            setEditModalData((prev) => ({ ...prev, comment: e.target.value }));
            }
            setEditModalValidationError("");
                }}
                onBlur={(e) => {
                  const { value } = e.target;
                  // Trim leading and trailing spaces for string values
                  if (typeof value === "string" && value.trim() !== value) {
                    setEditModalData((prev) => ({ ...prev, comment: value.trim() }));
                  }
                }}
          multiline
          rows={3}
        />
        {editModalValidationError && (
          <Typography
            variant="body2"
            color="error"
            style={{
              marginTop: 8,
              padding: "8px 12px",
              backgroundColor: "#ffebee",
              border: "1px solid #f44336",
              borderRadius: 4,
            }}
          >
            {editModalValidationError}
          </Typography>
        )}
        <Typography variant="caption" color="textSecondary" style={{ marginTop: 4 }}>
          Note - If reason code is not entered, comment field is mandatory
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Box display="flex" justifyContent="center">
          <Button
            variant="contained"
            style={{ borderRadius: 30 }}
            color="primary"
            onClick={handleSaveFieldEdit}
            disabled={saving}
            endIcon={saving ? <CircularProgress size={20} /> : <ArrowForwardIos style={{ fontSize: 15 }} />}
          >
            {saving ? "Saving..." : "Save changes"}
          </Button>
        </Box>
      </Grid>
    </Grid>
  </Box>
</Modal>

      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </>
  );
};

export default DigitizedConsumption;